import { render, staticRenderFns } from "./ProductPage.vue?vue&type=template&id=349ff2ac&scoped=true&"
import script from "./ProductPage.vue?vue&type=script&lang=js&"
export * from "./ProductPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductPage.vue?vue&type=style&index=0&id=349ff2ac&lang=scss&scoped=true&"
import style1 from "./ProductPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ff2ac",
  null
  
)

export default component.exports